<template>
    <div>
        <!-- 顶部欢迎及注册登录按钮导航 -->
        <header-top/>
        <!-- 顶部公司logo及导航栏 -->
        <logo-head></logo-head>
        <!-- 导航栏 -->
        <nav-head></nav-head>
        <!-- 商品信息主体 -->
        <div class="w-100 goodsInfoOut">
            <div class="goodsInfoContent">
                <!-- 面包屑导航 -->
                <div class="breadCrumb">
                    <span>当前位置：</span>
                    <div class="pl-1 pt-1">
                        <el-breadcrumb separator="/">
                            <el-breadcrumb-item :to="{ path: '/' }">易知网</el-breadcrumb-item>
                            <el-breadcrumb-item
                            ><a :href="`${mbxLink}?type=${type}`">{{mbx}}</a></el-breadcrumb-item
                            >
                            <el-breadcrumb-item>商品详情</el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                </div>
                <!-- 商品图片信息及恒达二维码 -->
                <div class="bg-white w-100">
                    <div class="infoTop">
                        <!-- 商品图片 -->
                        <div class="goodsImg border mr-4 d-flex" 
						style="justify-content: center;align-items: center;">
							<div style="font-size:34px;color: #999;">{{mbx}}</div>
                        </div>
                        <!-- 商品描述 -->
                        <div class="goodsDesc">
                            <div class="title mt-3">{{hotPatent.name}}</div>
                            <div class="d-flex pt-4">
                                <span>投资意向金额：<span
                                        style="color: #C32A1A;font-size: 18px;">{{hotPatent.money}}</span></span>
                            </div>
                            <div class="descTypeInfo mt-4">
                                <div class="pl-3" style="color: #999;">
                                    <p class="pt-1">类型：{{hotPatent.type}}</p>
                                    <p>类别：{{hotPatent.category}}</p>
                                    <p>发布日期：{{hotPatent.createAt}}</p>
                                    <p>发布人：{{hotPatent.userName}}</p>
                                </div>
                            </div>
                            <div class="pt-4">
								<span>想了解更多？扫描右侧二维码添加微信咨询</span>
                            </div>
                        </div>
                        <!-- 联系方式 -->
                        <div class="wxPhone">
                            <div class="imgContent">
                                <img :src="wxImg" width="180" height="180">
                            </div>
                            <div style="margin-left: 30px;text-align: center;padding-top: 10px;">想要了解更多？微信扫一扫</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 商品信息描述 -->
        <div class="infoDesc">
            <div class="descContent">
                <!-- 左侧商品描述 -->
                <div class="leftDesc">
                    <!-- 标题导航 -->
                    <div>
                        <el-menu default-active="1" class="el-menu-demo" mode="horizontal" text-color="#C32A1A"
                                 active-text-color="#C32A1A">
                            <el-menu-item index="1" style="margin-left:20px;">详情信息</el-menu-item>
                        </el-menu>
                    </div>
                    <!-- 专利详情 -->
                    <div class="goodDetailDesc">
                        <div v-html="hotPatent.introduce"></div>
                    </div>
                </div>
                <!-- 右侧推荐商品列表 -->
                <div class="rightImgList">
                    <!-- 推荐标题 -->
                    <div style="height: 60px;font-size: 18px;font-weight: bold;" class="p-4">
                        精选推荐
                    </div>
                    <!-- 商品列表 -->
                    <div>
                        <div v-for="(item,index) in hotList" class="d-inline-block hot_card_list ml-5 mb-3" :key="index"
                             style="cursor: pointer;">
                            <show-card :imgUrl="item.logoUrl" :titleDesc="item.name" :price="item.number"
                                       @click="goodsShow(item.id,'精选推荐')"></show-card>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 联系购买填写称呼弹窗 -->
        <el-dialog v-model="wantBuyDialog" title="怎么称呼您" width="300px">
            <el-form :model="wantBuyForm">
                <el-form-item label="请输入您的称呼" :label-width="formLabelWidth">
                    <el-input v-model="wantBuyForm.name" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="" prop="sex">
                    <el-radio-group v-model="wantBuyForm.sex">
                        <el-radio label="先生"></el-radio>
                        <el-radio label="女士"></el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <template #footer>
		      <span class="dialog-footer">
		        <el-button @click="wantBuyDialog = false">取消</el-button>
		        <el-button type="primary" @click="confirmCommit"
                >确定</el-button
                >
		      </span>
            </template>
        </el-dialog>
        <!-- 底部导航 -->
        <div>
            <Footer border></Footer>
        </div>
    </div>
</template>

<script>
    import HeaderTop from '@/components/headerTop/headerTop.vue'
    import LogoHead from '@/components/logoHead/logoHead.vue'
    import showCard from '@/components/showCard/showCard.vue'
    import NavHead from '@/components/navHead/navHead.vue'
    import Footer from '@/components/footer/footer.vue'
    import {ElNotification} from 'element-plus'

    export default {
        components: {
            HeaderTop,
            showCard,
            LogoHead,
            NavHead,
            Footer
        },
        data() {
            return {
                hotPatent: {},
                // 想要购买弹窗
                wantBuyDialog: false,
                // 个人信息弹窗
                wantBuyForm: {
                    name: '',
                    sex: ''
                },
				loading:false,
                // 收藏状态
                collection: false,
				// 微信二维码
				wxImg:'',
                hotList: [],
                mbx: '',
                mbxLink: '',
                id: 0,
                type: ''
            }
        },
        mounted() {
            this.mbx = this.$route.query.mbx
            this.mbxLink = this.$route.query.mbxLink
            this.id = this.$route.query.id
            this.type = this.$route.query.type
            this.getHotPatent(this.id)
			this.getHotList()
			this.getWxImg()
        },
        methods: {
            // 获取数据
            getHotPatent(id) {
                let vm = this
				vm.loading = true
                let linkUrl = `/api/want/buy/detailFindById/${id}`
                this.axios.get(linkUrl).then(res => {
					vm.hotPatent = res.data.data
					vm.collection = res.data.data.collectMark
					vm.loading = false
                }).catch(err=>{
					vm.loading = false
				})
            },
			// 获取精选推荐数据
			getHotList(){
				let vm = this
				this.axios.get('/api/brand/findHotBrandByType',{params:{type:'brand', count:3}
				}).then(res => {
					this.hotList = res.data.data
				})
			},
			// 获取二维码
			getWxImg(){
				this.axios.get('/api/material/findMaterial').then(res => {
					this.wxImg = res.data.data.qrCodeUrl
				})
			},
            // 点击联系购买
            buyForm(id) {
                let vm = this
                let isLogin = window.sessionStorage.getItem('token')
                if (!isLogin) {
                    this.$router.push('/login')
                } else {
                    let user = JSON.parse(window.sessionStorage.getItem('user'))
                    if (!user.name) {
                        // 打开弹窗
                      vm.wantBuyDialog = true
					  return
                    }
                    // 提交联系购买需求事件
                    vm.commitBuyInfo()
                }
            },
            // 进入商品详情页
            goodsShow(id, mbx, mbxLink) {
                let routeData = this.$router.resolve({
                    path: '/goodsInfo',
                    query: {
                        id: id,
                        mbx: mbx,
                        mbxLink: mbxLink
                    }
                })
                window.open(routeData.href, '_blank');
            },
        },
    }
</script>

<style scoped>
    /* 外层容器 */
    .goodsInfoOut {
        width: 100%;
        overflow: hidden;
        background-color: #f8f8f8;
    }

    .goodsInfoContent {
        width: 1200px;
        min-height: 500px;
        margin: 0 auto;
        margin-top: 5px;
    }

    .breadCrumb {
        display: flex;
        margin-top: 20px;
        margin-bottom: 20px;
    }

    /* 图片信息二维码 */
    .infoTop {
        width: 1200px;
        height: 450px;
        background-color: #fff;
        display: flex;
        padding: 15px;
    }

    .infoTop .goodsImg {
        width: 350px;
        height: 320px;
    }

    .infoTop .goodsDesc {
        width: 570px;
        min-height: 450px;
    }

    .infoTop .goodsDesc .title {
        font-size: 16px;
        color: #333;
        font-weight: bold;
    }

    /* 商品信息类型 */
    .descTypeInfo {
        width: 550px;
        height: 150px;
        background-color: #f8f8f8;
    }

    /* 右侧二维码窗口 */
    .wxPhone {
        height: 500px;
    }

    .wxPhone .imgContent {
        width: 200px;
        height: 200px;
        margin-left: 30px;
        border: 2px solid #f0f0f0;
        text-align: center;
        margin-top: 30px;
    }

    /*  下方商品详情 */
    .infoDesc {
        width: 100%;
        background-color: #f8f8f8;
        overflow: hidden;
    }

    .infoDesc .descContent {
        width: 1200px;
        min-height: 850px;
        margin: 0 auto;
        display: flex;
        margin-bottom: 20px;
    }

    .infoDesc .descContent .leftDesc {
        width: 870px;
        min-height: 850px;
        background-color: #fff;
    }

    .infoDesc .descContent .rightImgList {
        width: 300px;
        min-height: 850px;
        background-color: #fff;
        margin-left: 30px;
    }

    .infoDesc .descContent .goodDetailDesc {
        width: 800px;
        min-height: 500px;
        margin: 0 auto;
        margin-top: 20px;
    }
</style>
